import React, { useMemo } from 'react';
import { navigatePage } from '@cap/share/src/utils/navigation/index';
import { Image } from '@cap/share/src/components/LazyLoadImage';
import { logger, lx } from '@cap/rzmt-core';
import classNames from 'classnames';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { getGrayTest } from '@cap/share/src/apis/course';
import Price from './components/Price';
import Person from './components/Person';
import { ENU_COURSE_TYPE_NAME, ENU_COURSE_TYPE } from '@/utils/course';
import { CourseData } from '@/types/course';
import './index.less';

interface CourseProps {
  courseData: CourseData;
  showLabel?: boolean; // 自定义是否展示自定义标签 默认不展示。
}

const Course: React.FC<CourseProps> = ({ courseData, showLabel = false }) => {
  const getLableName = (generalLabels) => {
    let labelName = '';
    if (generalLabels && generalLabels.length > 0) {
      labelName = generalLabels[0].name;
    }
    return labelName;
  };

  const getTypeName = (type) => {
    const typeVal = type ? parseInt(type, 10) : 0;
    return ENU_COURSE_TYPE_NAME[typeVal];
  };

  const renderData = useMemo(() => {
    const data = { ...courseData };
    data.labelName = getLableName(courseData.generalLabels);
    data.typeName = getTypeName(courseData.type);
    return data;
  }, [courseData]);

  const customLableList = useMemo(() => {
    const { customLabels } = courseData;

    return customLabels && customLabels.length > 0 ? customLabels : [];
  }, [courseData]);

  const titleClass = useMemo(() => {
    return customLableList.length > 0 ? 'oneellipsis' : 'twoellipsis';
  }, [customLableList]);

  const onClickRemind = async (item: CourseData, event: React.MouseEvent) => {
    event.stopPropagation();
    lx.moduleClick({
      bid: 'b_donation_9z292f81_mc',
    });
    const { id, type, shortUrl, liveCourseLessonId, tenantId } = item;

    let urlPrefix = '/i/college';

    if ([ENU_COURSE_TYPE.VIDEO, ENU_COURSE_TYPE.ARTICLE].includes(type)) {
      try {
        const res = await getGrayTest({ tenant: shortUrl, tenantId });
        const { gray } = res.data || { gray: false };
        if (gray) {
          urlPrefix = '/web';
        }
      } catch (err) {
        logger.error(`灰度接口报错 ${err}`);
      }
    }

    const url = `${urlPrefix}/${shortUrl}/${ENU_COURSE_TYPE[type]}/${id}${
      type === 5 ? `?chapterId=${liveCourseLessonId || ''}` : ''
    }`;
    navigatePage(url, { windowOpen: true });
  };

  return (
    <div className="curriculum-card">
      <div className="onebigpic-inner-block" onClick={(event) => onClickRemind(renderData, event)}>
        {/* 热门标签 */}
        {renderData.labelName && <i className="label">{renderData.labelName}</i>}
        {/* 课程封面图 */}
        <Image className="curriculum-card-img" src={courseData.coverImageUrl} />

        {/* 课程标题和价格展示 */}
        <div className="content">
          <div className="content-content">
            <div className={classNames('content-wholetitle', titleClass)}>
              {renderData.certificateId && <div className="content-certifylabel">认证</div>}
              <p className="content-title">{courseData.title}</p>
            </div>
            {showLabel && (
              <p className="content-label-panel">
                {renderData.labels.map((label) => (
                  <span key={label} className="content-label">
                    {label}
                  </span>
                ))}
              </p>
            )}
            <div className="content-custom">
              {customLableList.map((customLabel) => (
                <div className="vertical-line">
                  <p className="content-customlabel" key={customLabel.id}>
                    {customLabel.name}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="content-price-person">
            <div className="person-content">
              <Person viewCount={renderData.viewCount} type={renderData.type} />

              <div className="price">
                {renderData.fixedPrice > 0 && (
                  <Price
                    price={renderData.price}
                    fixedPrice={renderData.fixedPrice}
                    showDiscountPrice={renderData.showDiscountPrice}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Course;
